import { isActionOf } from "typesafe-actions";
import { from, filter, switchMap, map, catchError, of } from "rxjs";
import { createModel, createModelRequest, getDashboardAction, getUnverifiedPhysicansAction } from "./actions";
import {reset} from 'redux-form';
import { ROUTES } from "../../../history";
import { RootEpic } from "../../../store/epics";
import { Model, Physician } from "../../../models";
import { initAction, putMessage } from "../../app/store/actions";

const initActionSuccessEpic: RootEpic = action$ => 
    action$.pipe(filter(isActionOf(initAction.success)),
    switchMap(({payload}) => {
        if(['admin', 'super_admin'].includes(payload.user.Role ?? '')) {
            return [getUnverifiedPhysicansAction.request()];
        }
        return [];
    }))


const getDashboardEpic: RootEpic = (action$, _, {api} ) =>
    action$.pipe(
        filter(isActionOf(getDashboardAction.request)),
        switchMap(() => {
            return from(api.dashboard())
            .pipe(
                map(res => {
                    if(res.code === 200) {
                        return getDashboardAction.success(res.data!.data);
                    }
                    if(res.code === 400 || res.code === 401) {
                        window.location.pathname = ROUTES.ADMIN_AUTH;
                        
                    }
                    return getDashboardAction.failure(res);
                })
            )
        })
    )

const getUnverifiedEpic: RootEpic = (action$, _, {api} ) =>
    action$.pipe(
        filter(isActionOf(getUnverifiedPhysicansAction.request)),
        switchMap(() => {
            return from(api.getModelList<Physician>({
                modelName: 'physician',
                returnType: 'count',
                crieteria: {
                    isVerified: false
                }, 
            }))
            .pipe(
                map(res => {
                    if(res.code === 200) {
                        return getUnverifiedPhysicansAction.success(res.data!.data.total);
                    }
                    if(res.code === 400 || res.code === 401) {
                        window.location.pathname = ROUTES.ADMIN_AUTH;
                        
                    }
                    return getUnverifiedPhysicansAction.failure('Network failure');
                })
            )
        })
    )

const createModelInitEpic: RootEpic = action$ => 
    action$.pipe(
        filter(isActionOf(createModel)),
        switchMap(({payload}) => {
            let data = payload.model;
            if(payload.mapFunc) {
                data = payload.mapFunc(data);
            }
    
            return of(createModelRequest.request({
                modelName: payload.modelName,
                payload: data,
            }));
        })
    )

const createModelEpic: RootEpic = (action$, _, {api} ) => 
 action$.pipe(
    filter(isActionOf(createModelRequest.request)),
    switchMap(({payload}) => {
       return from(api.createModel<Model>(payload))
        .pipe(
            map(v => {
                return createModelRequest.success({
                    model: v.data!.data.payload!,
                    modelName: payload.modelName
                })
            }),
            catchError((err) => {
                return [createModelRequest.failure({
                     error: err,
                    modelName: payload.modelName
                },),  putMessage({type: 'error', message: 'An error occurred'})]
            })
        )
    })
 )

const createModelSuccessEpic: RootEpic = action$ => 
    action$.pipe(
        filter(isActionOf(createModelRequest.success)),
        switchMap(({payload}) => {
            
            return [putMessage({type: 'success', message: `${payload.modelName} created successfully`}), reset(`${payload.modelName}-create`)];
        })
    )


const DashboardEpics = [
        getDashboardEpic,
        getUnverifiedEpic,
        initActionSuccessEpic,
        createModelInitEpic,
        createModelEpic,
        createModelSuccessEpic,
];

export default DashboardEpics;
